<template>
  <div class="xcard">
    <div class="row">
      <div class="col-sm-5"> 
        <input class="btn btn-sm" type="file" id="fileUpload" />
      </div>
      <div class="col-sm-4">
        <input class="btn btn-sm btn-success" type="button" id="upload" value="Visualizar" @click="Upload()" />
      </div>
    </div>
    <hr />

    <div class="table-responsive">
      <table class="table table-condensed">
        <thead>
          <tr>
            <th>Nro</th>
            <th>Documento</th>
            <th>Nombres</th>
            <th>Apellido 1</th>
            <th>Apellido 2</th>
            <th>Telefono 1</th>
            <th>Correo</th>
            <th>Genero</th>
            <th>Estado</th>
            <th>Opciones</th>
          </tr>
        </thead>

        <tbody>
          <tr :key="ind" v-for="(e,ind) in estudiantes">
            <td> {{ind+1}} </td>
            <td> {{e.num_doc}} </td>
            <td> {{e.nombres}} </td>
            <td> {{e.pri_apellido}} </td>
            <td> {{e.seg_apellido}} </td>
            <td> {{e.telefono1}} </td>
            <td> {{e.email}} </td>
            <td> {{e.sexo}} </td>
            <td> {{e.estado}} </td>
            <th>
              <button class="btn btn-sm btn-default" title="Generar Certificado" @click="generarCertificado(e)"> 
                <span class="glyphicon glyphicon-open-file"></span>
              </button>
            </th>
          </tr>
        </tbody>
      </table>

      <Certificado id="modalcertificado" :model="modelcertificado"/>
      <!-- <button v-if="estudiantes.length>0" :disabled="subiendo" class="btn btn-sm btn-azul" @click="subir()"> Subir estudiantes </button> -->
    </div>
    <div id="dvExcel">
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'
import Certificado from '@/components/ACertificadoWebinar'

export default {
  data(){
    return{
      subiendo: false,
      estudiantes:[],
      modelcertificado:{ inscripcion:{id:-1} },
    }
  },
  components:{ Certificado },
  methods:{
    Upload() {
      var vue = this;
        //Reference the FileUpload element.
        var fileUpload = document.getElementById("fileUpload");
 
        //Validate whether File is valid Excel file.
        var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (regex.test(fileUpload.value.toLowerCase())) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();
 
                //For Browsers other than IE.
                if (reader.readAsBinaryString) {
                    reader.onload = function (e) {
                        vue.processExcel(e.target.result);
                    };
                    reader.readAsBinaryString(fileUpload.files[0]);
                } else {
                    //For IE Browser.
                    reader.onload = function (e) {
                        var data = "";
                        var bytes = new Uint8Array(e.target.result);
                        for (var i = 0; i < bytes.byteLength; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        vue.processExcel(data);
                    };
                    reader.readAsArrayBuffer(fileUpload.files[0]);
                }
            } else {
                alert("This browser does not support HTML5.");
            }
        } else {
            alert("Por favor seleccione un archivo excel valido.");
        }
    },
    generarCertificado( ins ){
      var cer = {estudiante:ins,programa:{}}
        window.sessionStorage.setItem( "xxinscripcion",JSON.stringify(cer) );
        this.modelcertificado.inscripcion = cer;
        window.console.log( "---------",cer )
        window.$('#modalcertificado').modal('show')
      },
    processExcel(data) {
      var vue = this;
        var workbook = window.XLSX.read(data, {
            type: 'binary'
        });
 
        var firstSheet = workbook.SheetNames[0];
        var excelRows = window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
 
          for (var i = 0; i < excelRows.length; i++) {
            window.console.log(  excelRows[i] )
            var nro = excelRows[i].nro;
            var doc = excelRows[i].documento;
            var nom = excelRows[i].nombres.trim();
            var ap1 = "";
            var ap2 = "";
            var tel = excelRows[i].telefono1.trim();
            var ema = excelRows[i].email.trim();
            var gen = "";
            vue.estudiantes.push( 
              {
                nro:nro,num_doc:doc,nombres:nom,pri_apellido:ap1,
                seg_apellido:ap2,telefono1:tel,email:ema,sexo:gen,
                tipo:"E",diestro:true,profesiones:[1],idciudad:1,iddepartamento:1,estado:"SUBIR"
              } 
            );
        }

        window.console.log( vue.estudiantes )
    },
    async subir(){
      this.subiendo = true;
      var vue = this;
      this.estudiantes.forEach( async function(e){
        e.estado = "SUBIENDO...";
        await vue.enviarDAtos( e );
      })
    },
    async enviarDAtos( estudiante ){
      var obj = window.Object.assign({},estudiante);
      delete obj.nro;
      delete obj.estado;
      if( !obj.seg_apellido ) delete obj.seg_apellido

      this.subiendo = true;
      var vue = this;
      var sql = gql`mutation{ createPersona(input:${window.stringifyObject(obj)}){ok,persona{id,num_doc,nombres,pri_apellido,seg_apellido},errors{message}} }`;
      vue.msg = '';
      window.console.log( sql );

      await this.$apollo.mutate({
        mutation: sql,
      }).then((data) => {
        if(data.data.createPersona.ok){
          window.console.log( data.data.createPersona )
          var es = vue.estudiantes.find( x => x.num_doc == obj.num_doc )
          if( es ) es.estado = "SUBIDO";
        }else{
          var errores = JSON.stringify(data.data.createPersona.errors);
          var ob = JSON.parse( errores );
          var vals = '';
          ob.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          vue.msg = '';
          //vue.subiendo = false;
          var est = vue.estudiantes.find( x => x.num_doc == obj.num_doc )
          if( est ) est.estado = vals;
          window.console.log( obj,vals )
        }

      }).catch((error) => {
        if( !error ) return;
        //this.subiendo = false;
        window.console.error(JSON.stringify(error));
        this.$notify( parseJsonError( error ) )
        var est = vue.estudiantes.find( x => x.num_doc == obj.num_doc )
        if( est ) est.estado = error;
      })
    }
  },
  mounted(){

  }
}
</script>